import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import type { GetSpecialOffersResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface OfferCardProps {
  className?: string;
  type: string;
  offer: GetSpecialOffersResponse;
}

export const OfferCard = (props: OfferCardProps) => {
  const { i18n, t } = useTranslation('concierge');

  return (
    <Link
      className={cn(
        'group flex flex-col overflow-hidden border border-light/70 dark:border-gray-black',
        PaletteUtils.isInsigniaPalette && 'rounded-sm',
        PaletteUtils.isVcfcPalette && 'rounded-xl',
        props.className,
      )}
      to={RoutePaths.conciergeOffer.onNavigate(props.type, props.offer.id)}
    >
      <div className={cn('relative h-48 overflow-hidden')}>
        <img
          className='h-full w-full object-cover transition-transform duration-300 group-hover:scale-105'
          src={props.offer.imageUrl}
          alt={props.offer.header}
        />
      </div>
      <div className='flex flex-col gap-1 p-3'>
        <Text tag='h3' weight='semibold' size='lg'>
          {props.offer.header}
        </Text>
        <Text tag='p' size='sm' color='secondary'>
          {props.offer.description}
        </Text>
        <Text tag='p' weight='semibold' size='sm' color='secondary'>
          {t('offer.validUntil', { date: dayjs(props.offer.to).locale(i18n.language).format('D MMMM YYYY') })}
        </Text>
      </div>
    </Link>
  );
};
